import gql from "graphql-tag";
import { number, shape, string } from "prop-types";

export default gql`
	query getCurrentCustomer {
		getCurrentCustomer {
			email
			firstName
			lastName
			address1
			address2
			address3
			countryID
			state
			city
			zipCode
			phone
			company
		}
	}
`;

export const currentCustomerPropTypes = shape({
	email: string,
	firstName: string,
	lastName: string,
	address1: string,
	address2: string,
	address3: string,
	countryID: number,
	state: string,
	city: string,
	zipCode: string,
	phone: string,
	company: string,
	error: string,
});

export const readCurrentCustomer = ({ data }) => data && data.getCurrentCustomer;
